<div class="dialog-default d-flex flex-column">
    <div class="d-flex flex-row m-2">
        <h1 class="m-0" mat-dialog-title>
            {{families.length}} responsable{{families.length > 0 ? 's' : ''}}
            lég{{families.length > 0 ? 'aux' : 'al'}} {{families.length > 0 ? 'peuvent' : 'peut'}}
            être associé{{families.length > 0 ? 's' : ''}} à ce jeune. Sélectionnez les responsables :
        </h1>
        <span class="flex-fill separator"></span>
        <button (click)="abortAction()"
                aria-label="Close"
                class="close"
                type="button">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="radio-group my-3 d-flex flex-fill">
        <app-dialog-select-young-inscription-family (radioChange)="onRadioChange($event)"
                                                    [families]="families"
                                                    class="d-flex flex-fill">
        </app-dialog-select-young-inscription-family>
    </div>
    <div class="my-md-3 my-5 row align-items-center justify-content-end">
        <button (click)="exit(true)" class="btn btn-outline-primary mr-5">Passer</button>
        <button (click)="exit()" class="btn btn-primary mr-5">Valider</button>
    </div>
</div>
